import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/components/actions/Button/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentManager"] */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/components/feedback/ConsentManager/ConsentManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/components/feedback/ToastContainer/ToastContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWithMenuItems"] */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/components/navigation/Navbar/NavbarWithMenuItems.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterForm"] */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/components/sections/Newsletter/NewsletterForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UrqlProvider"] */ "/vercel/path0/node_modules/@digitale-kumpel/client-common/src/urqlClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PagePreviewList"] */ "/vercel/path0/src/components/PagePreviewList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/vercel/path0/src/components/Slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/vercel/path0/src/components/Video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntlProvider"] */ "/vercel/path0/src/lib/i18nClient.tsx");
